export function isTestEnvironment() {
  try {
    if (import.meta?.env?.VITEST) return true;
    if (import.meta?.env?.MODE === "test") return true;
  } catch {
    // ignore
  }

  try {
    if (globalThis?.process?.env?.VITEST) return true;
    if (globalThis?.process?.env?.NODE_ENV === "test") return true;
  } catch {
    // ignore
  }

  return false;
}

